<!-- eslint-disable vue/no-static-inline-styles -->
<script lang="ts" setup>
import type { SkeletonVariants } from '~/components/ui/skeleton';

import {
	CommandGroup,
	CommandItem
} from '@/components/SearchSuggestRadixCommand';
import { cn } from '@/utils';

interface LoadingGroupProps {
	groupHeadingClasses: string;
	groupItemWrapperClasses: string;
	groupIconClasses: string;
	groupItemTextClasses: string;
	groupItemSubTextClasses: string;
	skeletonVariant: SkeletonVariants['variant'];
}
withDefaults(defineProps<Partial<LoadingGroupProps>>(), {
	groupHeadingClasses: '',
	groupIconClasses: '',
	groupItemWrapperClasses: '',
	groupItemTextClasses: '',
	groupItemSubTextClasses: '',
	skeletonVariant: 'white'
});

defineModel<boolean>('active', { required: true });
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
	<CommandGroup v-if="active" class="overflow-hidden p-0">
		<template #heading>
			<div
				:class="
					cn(
						'flex h-12 cursor-default items-center gap-3 px-4 font-matter-sq text-lg font-normal leading-normal tracking-[-0.36px] text-primary',
						groupHeadingClasses
					)
				"
			>
				<div class="flex h-full items-center" :class="groupIconClasses">
					<Skeleton
						:is-active="true"
						:variant="skeletonVariant"
						class="size-5"
					/>
				</div>
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-full max-w-[100px]"
				/>
			</div>
		</template>

		<CommandItem
			v-for="index in 3"
			:key="`suggest-item-${index}`"
			:value="index"
			:class="
				cn(
					'flex flex-col items-start bg-transparent py-2 pl-12 pr-4 opacity-100',
					groupItemWrapperClasses
				)
			"
			disabled
		>
			<div class="w-full space-y-2">
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-4 w-full max-w-[160px]"
				/>
				<small
					:class="
						cn(
							'block text-start text-xs font-normal leading-normal text-primary-light-2',
							groupItemSubTextClasses
						)
					"
				>
					<Skeleton
						:is-active="true"
						:variant="skeletonVariant"
						class="h-3 w-full max-w-[377px]"
					/>
				</small>
			</div>
		</CommandItem>
	</CommandGroup>
</template>
